"use strict";

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var types_1 = require("../../types");

var procedures_1 = require("../../procedures");

var SubModule_1 = require("./SubModule");

var Checkpoint_1 = require("../Checkpoint");

var PolymathError_1 = require("../../PolymathError");

var DividendDistribution_1 = require("../DividendDistribution");

var Tokenholder_1 = require("../Tokenholder");
/**
 * Namespace that handles all Tokenholder related functionality
 */


var Tokenholders =
/*#__PURE__*/
function (_SubModule_1$SubModul) {
  _inherits(Tokenholders, _SubModule_1$SubModul);

  function Tokenholders() {
    var _this;

    _classCallCheck(this, Tokenholders);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Tokenholders).apply(this, arguments));
    /**
     * Add/modify investor data. For an investor to be able to hold, sell or purchase tokens, his address (and other KYC data)
     * must be added/modified via this method
     *
     * @param args.tokenholderData - array of tokenholder data to add/modify
     */

    _this.modifyData = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                procedure = new procedures_1.ModifyTokenholderData(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    /**
     * Revoke KYC for a group of tokenholder addresses. Supplied addresses must have valid KYC
     */


    _this.revokeKyc = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var procedure;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                procedure = new procedures_1.RevokeKyc(Object.assign({
                  symbol: this.securityToken.symbol
                }, args), this.context);
                return _context2.abrupt("return", procedure.prepare());

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    /**
     * Create a snapshot of the balances of every tokenholder at the current date
     */


    _this.createCheckpoint = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var context, securityToken, symbol, procedure;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                context = this.context, securityToken = this.securityToken;
                symbol = securityToken.symbol;
                procedure = new procedures_1.CreateCheckpoint({
                  symbol: symbol
                }, context);
                return _context3.abrupt("return", procedure.prepare());

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    };
    /**
     * Retrieve list of checkpoints and their corresponding dividend distributions of every type
     */


    _this.getCheckpoints = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _this$context, contractWrappers, factories, _this$securityToken, symbol, uid, securityToken, allDividends, checkpoints;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this$context = this.context, contractWrappers = _this$context.contractWrappers, factories = _this$context.factories;
                _this$securityToken = this.securityToken, symbol = _this$securityToken.symbol, uid = _this$securityToken.uid;
                _context4.prev = 2;
                _context4.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 5:
                securityToken = _context4.sent;
                _context4.next = 11;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 11:
                _context4.next = 13;
                return contractWrappers.getAllDividends({
                  securityTokenSymbol: symbol
                });

              case 13:
                allDividends = _context4.sent;
                _context4.next = 16;
                return contractWrappers.getCheckpoints({
                  securityToken: securityToken
                });

              case 16:
                checkpoints = _context4.sent;
                return _context4.abrupt("return", checkpoints.map(function (_a) {
                  var index = _a.index,
                      checkpoint = __rest(_a, ["index"]);

                  var checkpointId = Checkpoint_1.Checkpoint.generateId({
                    securityTokenId: uid,
                    index: index
                  });
                  var checkpointDividends = allDividends.filter(function (dividend) {
                    return dividend.checkpointId === index;
                  });
                  var dividendDistributions = checkpointDividends.map(function (distribution) {
                    return factories.dividendDistributionFactory.create(DividendDistribution_1.DividendDistribution.generateId({
                      securityTokenId: uid,
                      index: index
                    }), Object.assign({}, distribution, {
                      checkpointId: checkpointId,
                      securityTokenSymbol: symbol
                    }));
                  });
                  return factories.checkpointFactory.create(checkpointId, Object.assign({}, checkpoint, {
                    dividendDistributions: dividendDistributions,
                    securityTokenSymbol: symbol
                  }));
                }));

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));
    };
    /**
     * Retrieve a checkpoint from the security token by index or UUID
     *
     * @param args - checkpoint uuid or object containing its index
     */


    _this.getCheckpoint = function (args) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var factories, securityTokenId, uid;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                factories = this.context.factories;
                securityTokenId = this.securityToken.uid;

                // fetch by UUID
                if (typeof args === 'string') {
                  uid = args;
                } else {
                  uid = Checkpoint_1.Checkpoint.generateId({
                    index: args.checkpointIndex,
                    securityTokenId: securityTokenId
                  });
                }

                return _context5.abrupt("return", factories.checkpointFactory.fetch(uid));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    };
    /**
     * Get data for all tokenholders associated to the Security Token
     */


    _this.getTokenholders = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this$context2, contractWrappers, factories, _this$securityToken2, securityTokenSymbol, securityTokenId, securityToken, generalTransferManager, _ref, _ref2, allKycData, allFlags, tokenholders, balances, i, _allKycData$i, address, canSendAfter, canReceiveAfter, expiryTime, _allFlags$i, isAccredited, canNotBuyFromSTO, balance, tokenholder;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this$context2 = this.context, contractWrappers = _this$context2.contractWrappers, factories = _this$context2.factories;
                _this$securityToken2 = this.securityToken, securityTokenSymbol = _this$securityToken2.symbol, securityTokenId = _this$securityToken2.uid;
                _context6.prev = 2;
                _context6.next = 5;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(securityTokenSymbol);

              case 5:
                securityToken = _context6.sent;
                _context6.next = 11;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6["catch"](2);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(securityTokenSymbol)
                });

              case 11:
                _context6.next = 13;
                return contractWrappers.getAttachedModules({
                  moduleName: contract_wrappers_1.ModuleName.GeneralTransferManager,
                  symbol: securityTokenSymbol
                }, {
                  unarchived: true
                });

              case 13:
                generalTransferManager = _context6.sent[0];
                _context6.next = 16;
                return Promise.all([generalTransferManager.getAllKYCData(), generalTransferManager.getAllInvestorFlags()]);

              case 16:
                _ref = _context6.sent;
                _ref2 = _slicedToArray(_ref, 2);
                allKycData = _ref2[0];
                allFlags = _ref2[1];
                tokenholders = [];
                _context6.next = 23;
                return Promise.all(allKycData.map(function (_ref3) {
                  var investor = _ref3.investor;
                  return securityToken.balanceOf({
                    owner: investor
                  });
                }));

              case 23:
                balances = _context6.sent;

                for (i = 0; i < allKycData.length; ++i) {
                  _allKycData$i = allKycData[i], address = _allKycData$i.investor, canSendAfter = _allKycData$i.canSendAfter, canReceiveAfter = _allKycData$i.canReceiveAfter, expiryTime = _allKycData$i.expiryTime;
                  _allFlags$i = allFlags[i], isAccredited = _allFlags$i.isAccredited, canNotBuyFromSTO = _allFlags$i.canNotBuyFromSTO;
                  balance = balances[i];
                  tokenholder = factories.tokenholderFactory.create(Tokenholder_1.Tokenholder.generateId({
                    securityTokenId: securityTokenId,
                    address: address
                  }), {
                    balance: balance,
                    canSendAfter: canSendAfter,
                    canReceiveAfter: canReceiveAfter,
                    kycExpiry: expiryTime,
                    isAccredited: isAccredited,
                    canBuyFromSto: !canNotBuyFromSTO,
                    securityTokenSymbol: securityTokenSymbol
                  });

                  if (!tokenholder.isRevoked() || tokenholder.balance.isGreaterThan(0)) {
                    tokenholders.push(tokenholder);
                  }
                }

                return _context6.abrupt("return", tokenholders);

              case 26:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));
    };
    /**
     * Retrieve the amount of wallets that ever held tokens or have any KYC data
     */


    _this.allTimeInvestorCount = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var contractWrappers, symbol, securityTokenInstance;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, symbol = this.securityToken.symbol;
                _context7.prev = 1;
                _context7.next = 4;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 4:
                securityTokenInstance = _context7.sent;
                _context7.next = 10;
                break;

              case 7:
                _context7.prev = 7;
                _context7.t0 = _context7["catch"](1);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                return _context7.abrupt("return", securityTokenInstance.getInvestorCount());

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 7]]);
      }));
    };
    /**
     * Retrieve the amount of wallets that currently hold tokens
     */


    _this.holderCount = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var contractWrappers, symbol, securityTokenInstance;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                contractWrappers = this.context.contractWrappers, symbol = this.securityToken.symbol;
                _context8.prev = 1;
                _context8.next = 4;
                return contractWrappers.tokenFactory.getSecurityTokenInstanceFromTicker(symbol);

              case 4:
                securityTokenInstance = _context8.sent;
                _context8.next = 10;
                break;

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](1);
                throw new PolymathError_1.PolymathError({
                  code: types_1.ErrorCode.FetcherValidationError,
                  message: "There is no Security Token with symbol ".concat(symbol)
                });

              case 10:
                return _context8.abrupt("return", securityTokenInstance.holderCount());

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 7]]);
      }));
    };

    return _this;
  }

  return Tokenholders;
}(SubModule_1.SubModule);

exports.Tokenholders = Tokenholders;